var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.js
var src_exports = {};
__export(src_exports, {
  DateField: () => DateField_default,
  DateRange: () => DateRange_default,
  DateRangeField: () => DateRangeField_default,
  default: () => Date_default
});
module.exports = __toCommonJS(src_exports);

// src/Date.js
var import_react = __toESM(require("react"));
var import_prop_types2 = __toESM(require("prop-types"));
var import_classnames = __toESM(require("classnames"));
var import_formik = require("formik");
var import_initialize = require("@availity/react-dates/initialize");
var import_react_dates = require("@availity/react-dates");
var import_reactstrap = require("reactstrap");
var import_moment2 = __toESM(require("moment"));

// polyfills/padStart.js
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength >>= 0;
    padString = String(typeof padString !== "undefined" ? padString : " ");
    if (this.length >= targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

// src/utils.js
var import_moment = __toESM(require("moment"));
var import_prop_types = __toESM(require("prop-types"));
var isoDateFormat = "YYYY-MM-DD";
var isOutsideRange = (min, max, format = "MM/DD/YYYY") => (day) => {
  let isOutsideMax = false;
  let isOutsideMin = false;
  if (min) {
    if (import_moment.default.isMoment(min)) {
      isOutsideMin = day.isBefore(min);
    }
    if (typeof min === "string") {
      isOutsideMin = day.isBefore((0, import_moment.default)(min, [isoDateFormat, format, "MMDDYYYY", "YYYYMMDD"]));
    }
    if (min.value !== void 0 && min.units) {
      isOutsideMin = day.isBefore((0, import_moment.default)().subtract(min.value, min.units));
    }
  }
  if (max) {
    if (import_moment.default.isMoment(max)) {
      isOutsideMax = day.isAfter(max);
    }
    if (typeof max === "string") {
      const maxMoment = (0, import_moment.default)(max, [isoDateFormat, format, "MMDDYYYY", "YYYYMMDD"]);
      if (!maxMoment._f || maxMoment._f.indexOf("H") === -1) {
        maxMoment.hour(23);
        maxMoment.minute(59);
        maxMoment.second(59);
      }
      isOutsideMax = day.isAfter(maxMoment);
    }
    if (max.value !== void 0 && max.units) {
      isOutsideMax = day.isAfter((0, import_moment.default)().add(max.value, max.units));
    }
  }
  return isOutsideMax || isOutsideMin;
};
var limitPropType = import_prop_types.default.oneOfType([
  import_prop_types.default.string,
  import_prop_types.default.shape({ value: import_prop_types.default.number, units: import_prop_types.default.string }),
  import_prop_types.default.shape({ _d: import_prop_types.default.string, _isValid: import_prop_types.default.func })
]);
var buildYearPickerOptions = (min, max, month, format = "MM/DD/YYYY") => {
  const yearPickerOptions = [];
  let minYear;
  let maxYear;
  if (min) {
    if (import_moment.default.isMoment(min)) {
      minYear = min.year();
    } else if (min.value !== void 0 && min.units) {
      minYear = (0, import_moment.default)().subtract(min.value, min.units).year();
    } else if (typeof min === "string") {
      const minMoment = (0, import_moment.default)(min, [isoDateFormat, format, "MMDDYYYY", "YYYYMMDD"]);
      minYear = minMoment.year();
    }
  } else {
    minYear = (0, import_moment.default)().year() - 100;
  }
  if (max) {
    if (import_moment.default.isMoment(max)) {
      maxYear = max.year();
    } else if (max.value !== void 0 && max.units) {
      maxYear = (0, import_moment.default)().add(max.value, max.units).year();
    } else if (typeof max === "string") {
      const maxMoment = (0, import_moment.default)(max, [isoDateFormat, format, "MMDDYYYY", "YYYYMMDD"]);
      maxYear = maxMoment.year();
    }
  } else {
    maxYear = (0, import_moment.default)().year();
  }
  if (month.year() > maxYear) {
    maxYear = month.year();
  } else if (month.year() < minYear) {
    minYear = month.year();
  }
  for (let year = minYear; year <= maxYear; year++) {
    yearPickerOptions.push({
      value: year,
      label: `${year}`
    });
  }
  return yearPickerOptions;
};

// src/Date.js
var isoDateFormat2 = "YYYY-MM-DD";
var yearPickerStyles = {
  minWidth: "100%"
};
var AvDate = (_a) => {
  var _b = _a, {
    className,
    name,
    innerRef,
    onChange,
    onPickerFocusChange,
    min,
    max,
    format = "MM/DD/YYYY",
    validate,
    datePickerProps,
    "data-testid": dataTestId,
    openDirection = "down"
  } = _b, attributes = __objRest(_b, [
    "className",
    "name",
    "innerRef",
    "onChange",
    "onPickerFocusChange",
    "min",
    "max",
    "format",
    "validate",
    "datePickerProps",
    "data-testid",
    "openDirection"
  ]);
  const { setFieldValue, setFieldTouched, validateField } = (0, import_formik.useFormikContext)();
  const [field, metadata] = (0, import_formik.useField)({
    name,
    validate
  });
  const [isFocused, setIsFocused] = (0, import_react.useState)(false);
  const classes = (0, import_classnames.default)(className, metadata.touched ? "is-touched" : "is-untouched", metadata.touched && metadata.error && "is-invalid", !field.value && "current-day-highlight");
  const pickerId = `${(attributes.id || name).replace(/[^\da-z]/gi, "")}-picker`;
  (0, import_react.useEffect)(() => {
    if (field.value || metadata.touched) {
      validateField(name);
    }
  }, [field.value, metadata.touched, name, validateField]);
  const onInputChange = (value) => {
    const date = (0, import_moment2.default)(value, [isoDateFormat2, format, "MMDDYYYY", "YYYYMMDD", "M/D/YYYY"], true);
    const isoFormatted = date.format(isoDateFormat2);
    setFieldValue(name, date.isValid() ? isoFormatted : date, false);
    setFieldTouched(name, true, false);
    if (date.isValid()) {
      if (isFocused !== false) {
        setIsFocused(false);
      }
      if (onChange) {
        onChange(isoFormatted);
      }
    }
  };
  const onPickerChange = (value) => {
    let val = value;
    if (val !== null) {
      if (val instanceof Object && val.isValid()) {
        val = val.format(isoDateFormat2);
      }
      setFieldValue(name, val, false);
      setFieldTouched(name, true, false);
    }
    if (onChange) {
      onChange(val);
    }
  };
  const onFocusChange = ({ focused }) => {
    if (!focused) {
      setFieldTouched(name, true, false);
    }
    if (focused !== void 0 && isFocused !== focused) {
      setIsFocused(focused);
    }
    if (onPickerFocusChange) {
      onPickerFocusChange({ focused });
    }
  };
  const getDateValue = () => {
    const date = (0, import_moment2.default)(field.value, [isoDateFormat2, format, "MMDDYYYY", "YYYYMMDD", "M/D/YYYY"], true);
    if (date.isValid())
      return date;
    return null;
  };
  const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
    const yearPickerOptions = buildYearPickerOptions(min, max, month, format);
    return /* @__PURE__ */ import_react.default.createElement(import_reactstrap.Row, null, /* @__PURE__ */ import_react.default.createElement(import_reactstrap.Col, null, /* @__PURE__ */ import_react.default.createElement("select", {
      "data-testid": "monthPicker",
      "aria-label": "month picker",
      value: month.month(),
      onChange: (e) => {
        onMonthSelect(month, e.target.value);
      }
    }, import_moment2.default.months().map((label, value) => /* @__PURE__ */ import_react.default.createElement("option", {
      key: label,
      value,
      "aria-label": label
    }, label)))), /* @__PURE__ */ import_react.default.createElement(import_reactstrap.Col, null, /* @__PURE__ */ import_react.default.createElement("select", {
      "data-testid": "yearPicker",
      "aria-label": "year picker",
      style: yearPickerStyles,
      value: month.year(),
      onChange: (e) => {
        onYearSelect(month, e.target.value);
      }
    }, yearPickerOptions.map(({ value, label }) => /* @__PURE__ */ import_react.default.createElement("option", {
      key: label,
      value,
      "aria-label": label
    }, label)))));
  };
  renderMonthElement.propTypes = {
    month: import_prop_types2.default.instanceOf(import_moment2.default),
    onMonthSelect: import_prop_types2.default.func,
    onYearSelect: import_prop_types2.default.func
  };
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_reactstrap.Input, {
    name,
    style: { display: "none" },
    className: classes
  }), /* @__PURE__ */ import_react.default.createElement(import_reactstrap.InputGroup, {
    disabled: attributes.disabled,
    className: classes,
    onChange: ({ target }) => target.id === pickerId && onInputChange(target.value),
    "data-testid": `date-input-group-${name}`
  }, /* @__PURE__ */ import_react.default.createElement(import_react_dates.SingleDatePicker, __spreadProps(__spreadValues({
    renderMonthElement,
    autoComplete: "date",
    numberOfMonths: 1
  }, datePickerProps), {
    disabled: attributes.disabled,
    id: pickerId,
    placeholder: format.toLowerCase(),
    date: getDateValue(),
    onDateChange: onPickerChange,
    focused: isFocused,
    onFocusChange,
    isOutsideRange: isOutsideRange(min, max),
    navPosition: "navPositionBottom",
    openDirection
  }))));
};
AvDate.propTypes = {
  name: import_prop_types2.default.string.isRequired,
  disabled: import_prop_types2.default.bool,
  className: import_prop_types2.default.string,
  min: limitPropType,
  max: limitPropType,
  onChange: import_prop_types2.default.func,
  onPickerFocusChange: import_prop_types2.default.func,
  innerRef: import_prop_types2.default.oneOfType([import_prop_types2.default.func, import_prop_types2.default.node]),
  format: import_prop_types2.default.string,
  "data-testid": import_prop_types2.default.string,
  validate: import_prop_types2.default.func,
  datePickerProps: import_prop_types2.default.object,
  openDirection: import_prop_types2.default.string
};
var Date_default = AvDate;

// src/DateField.js
var import_react2 = __toESM(require("react"));
var import_prop_types3 = __toESM(require("prop-types"));
var import_form = require("@availity/form");
var DateField = (_a) => {
  var _b = _a, { name, label, labelClass, labelHidden, labelAttrs, id = name, required, helpId } = _b, props = __objRest(_b, ["name", "label", "labelClass", "labelHidden", "labelAttrs", "id", "required", "helpId"]);
  return /* @__PURE__ */ import_react2.default.createElement(import_form.FormGroup, {
    for: name
  }, label && /* @__PURE__ */ import_react2.default.createElement(import_form.Label, __spreadValues({
    for: `${id}-picker`,
    className: labelClass,
    hidden: labelHidden,
    required,
    helpId
  }, labelAttrs), label), /* @__PURE__ */ import_react2.default.createElement(Date_default, __spreadValues({
    name,
    id
  }, props)), /* @__PURE__ */ import_react2.default.createElement(import_form.Feedback, {
    name
  }));
};
DateField.propTypes = {
  id: import_prop_types3.default.string,
  name: import_prop_types3.default.string.isRequired,
  label: import_prop_types3.default.node,
  labelClass: import_prop_types3.default.string,
  labelHidden: import_prop_types3.default.bool,
  labelAttrs: import_prop_types3.default.object,
  required: import_prop_types3.default.bool,
  helpId: import_prop_types3.default.string
};
var DateField_default = DateField;

// src/DateRange.js
var import_react3 = __toESM(require("react"));
var import_prop_types4 = __toESM(require("prop-types"));
var import_reactstrap2 = require("reactstrap");
var import_react_dates2 = require("@availity/react-dates");
var import_classnames2 = __toESM(require("classnames"));
var import_formik2 = require("formik");
var import_pick = __toESM(require("lodash/pick"));
var import_moment3 = __toESM(require("moment"));
var isoDateFormat3 = "YYYY-MM-DD";
var relativeRanges = {
  Today: {
    startDate: (0, import_moment3.default)({ hour: 0 }),
    endDate: (0, import_moment3.default)({ hour: 0 })
  },
  "Last 7 Days": {
    startDate: (0, import_moment3.default)({ hour: 0 }).subtract(6, "days"),
    endDate: (0, import_moment3.default)({ hour: 0 })
  },
  "Last 30 Days": {
    startDate: (0, import_moment3.default)({ hour: 0 }).subtract(29, "days"),
    endDate: (0, import_moment3.default)({ hour: 0 })
  },
  "Last 120 Days": {
    startDate: (0, import_moment3.default)({ hour: 0 }).subtract(119, "days"),
    endDate: (0, import_moment3.default)({ hour: 0 })
  },
  "Last 6 Months": {
    startDate: (0, import_moment3.default)({ hour: 0 }).subtract(6, "months"),
    endDate: (0, import_moment3.default)({ hour: 0 })
  },
  "Last 12 Months": {
    startDate: (0, import_moment3.default)({ hour: 0 }).subtract(12, "months"),
    endDate: (0, import_moment3.default)({ hour: 0 })
  }
};
var yearPickerStyles2 = {
  minWidth: "100%"
};
var hiddenInputStyles = {
  display: "none"
};
var DateRange = (_a) => {
  var _b = _a, {
    id,
    min,
    max,
    name,
    validate,
    onChange,
    onPickerFocusChange,
    innerRef,
    className,
    format = isoDateFormat3,
    ariaDescribedBy,
    datepickerProps,
    "data-testid": dataTestId,
    autoSync,
    ranges: propsRanges,
    customArrowIcon,
    openDirection = "down",
    allowInvalidDates = false
  } = _b, attributes = __objRest(_b, [
    "id",
    "min",
    "max",
    "name",
    "validate",
    "onChange",
    "onPickerFocusChange",
    "innerRef",
    "className",
    "format",
    "ariaDescribedBy",
    "datepickerProps",
    "data-testid",
    "autoSync",
    "ranges",
    "customArrowIcon",
    "openDirection",
    "allowInvalidDates"
  ]);
  const { setFieldValue, setFieldTouched, validateField } = (0, import_formik2.useFormikContext)();
  const [{ value = {} }, metadata] = (0, import_formik2.useField)({ name, validate });
  const [focusedInput, setFocusedInput] = (0, import_react3.useState)(null);
  const startId = `${(id || name).replace(/[^\da-z]/gi, "")}-start`;
  const endId = `${(id || name).replace(/[^\da-z]/gi, "")}-end`;
  const startValue = value.startDate || "";
  const endValue = value.endDate || "";
  const startValueMoment = (0, import_react3.useMemo)(() => (0, import_moment3.default)(startValue, [isoDateFormat3, format, "MMDDYYYY", "YYYYMMDD", "M/D/YYYY"]), [startValue, format]);
  const endValueMoment = (0, import_react3.useMemo)(() => (0, import_moment3.default)(endValue, [isoDateFormat3, format, "MMDDYYYY", "YYYYMMDD", "M/D/YYYY"]), [endValue, format]);
  const classes = (0, import_classnames2.default)("input-group-date-range", className, metadata.touched ? "is-touched" : "is-untouched", metadata.touched && metadata.error && "is-invalid", !startValue && !endValue && "current-day-highlight");
  (0, import_react3.useEffect)(() => {
    if (metadata.touched || startValue || endValue) {
      validateField(name);
    }
  }, [metadata.touched, startValue, endValue, name, validateField]);
  const onInputChange = (val) => {
    const isStart = focusedInput === "startDate";
    const date = (0, import_moment3.default)(val, [isoDateFormat3, format, "MMDDYYYY", "YYYYMMDD", "M/D/YYYY"], true);
    const valueToSet = date.isValid() ? date.format(format) : allowInvalidDates ? val : null;
    setFieldValue(name, {
      startDate: isStart ? valueToSet : startValue,
      endDate: !isStart ? valueToSet : endValue
    }, false);
    if (focusedInput && isStart && date.isValid()) {
      setFocusedInput("endDate");
    } else if (focusedInput && !isStart && date.isValid()) {
      setFocusedInput();
    }
  };
  const onDatesChange = ({ startDate, endDate }) => {
    const _startDate = startDate && startDate.format(format) || startValue;
    const _endDate = endDate && endDate.format(format) || endValue;
    setFieldValue(name, {
      startDate: _startDate,
      endDate: _endDate
    }, false);
    if (_startDate && _endDate) {
      setFieldTouched(name, true, false);
    }
    if (onChange) {
      onChange({
        startDate: _startDate,
        endDate: _endDate
      });
    }
  };
  const syncDates = () => {
    if (!metadata.touched) {
      let value2;
      if (!startValue || !endValue) {
        value2 = startValue || endValue;
      }
      if (value2) {
        setFieldValue(name, {
          startDate: value2,
          endDate: value2
        }, false);
        setFieldTouched(name, true, false);
      }
    }
  };
  const onFocusChange = (input) => {
    if (!input && !autoSync)
      setFieldTouched(name, true, false);
    if (autoSync)
      syncDates();
    setFocusedInput(input);
    if (onPickerFocusChange)
      onPickerFocusChange({ focusedInput: input });
  };
  const getDateValue = (val) => {
    const date = (0, import_moment3.default)(val, [isoDateFormat3, format, "MMDDYYYY", "YYYYMMDD", "M/D/YYYY"], true);
    if (date.isValid())
      return date;
    return null;
  };
  const renderDateRanges = () => {
    let ranges;
    if (typeof propsRanges === "boolean" && propsRanges) {
      ranges = relativeRanges;
    } else if (propsRanges) {
      ranges = Array.isArray(propsRanges) ? (0, import_pick.default)(relativeRanges, propsRanges) : propsRanges;
    }
    return ranges ? /* @__PURE__ */ import_react3.default.createElement("div", {
      className: "d-flex flex-column ml-2 mt-2"
    }, Object.keys(ranges).map((relativeRange) => {
      const { startDate, endDate } = ranges[relativeRange];
      const isSelected = startDate.isSame(startValueMoment, "millisecond") && endDate.isSame(endValueMoment, "millisecond");
      return /* @__PURE__ */ import_react3.default.createElement(import_reactstrap2.Button, {
        key: relativeRange,
        className: "my-1",
        color: isSelected ? "primary" : "default",
        size: "sm",
        onClick: () => {
          onDatesChange({
            startDate,
            endDate
          });
          setFocusedInput(null);
        }
      }, relativeRange);
    })) : null;
  };
  const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
    const yearPickerOptions = buildYearPickerOptions(min, max, month, format);
    return /* @__PURE__ */ import_react3.default.createElement(import_reactstrap2.Row, null, /* @__PURE__ */ import_react3.default.createElement(import_reactstrap2.Col, null, /* @__PURE__ */ import_react3.default.createElement("select", {
      "data-testid": "monthPicker",
      "aria-label": "month picker",
      value: month.month(),
      onChange: (e) => {
        onMonthSelect(month, e.target.value);
      }
    }, import_moment3.default.months().map((label, value2) => /* @__PURE__ */ import_react3.default.createElement("option", {
      key: label,
      value: value2,
      "aria-label": label
    }, label)))), /* @__PURE__ */ import_react3.default.createElement(import_reactstrap2.Col, null, /* @__PURE__ */ import_react3.default.createElement("select", {
      "data-testid": "yearPicker",
      "aria-label": "year picker",
      style: yearPickerStyles2,
      value: month.year(),
      onChange: (e) => {
        onYearSelect(month, e.target.value);
      }
    }, yearPickerOptions.map(({ value: value2, label }) => /* @__PURE__ */ import_react3.default.createElement("option", {
      key: label,
      value: value2,
      "aria-label": label
    }, label)))));
  };
  renderMonthElement.propTypes = {
    month: import_prop_types4.default.instanceOf(import_moment3.default),
    onMonthSelect: import_prop_types4.default.func,
    onYearSelect: import_prop_types4.default.func
  };
  return /* @__PURE__ */ import_react3.default.createElement(import_react3.default.Fragment, null, /* @__PURE__ */ import_react3.default.createElement(import_reactstrap2.Input, {
    name,
    style: hiddenInputStyles,
    className: classes
  }), /* @__PURE__ */ import_react3.default.createElement(import_reactstrap2.InputGroup, {
    disabled: attributes.disabled,
    className: classes,
    "data-testid": `date-range-input-group-${name}`,
    onChange: ({ target }) => {
      if (target.id === startId || target.id === endId) {
        onInputChange(target.value);
      }
    }
  }, /* @__PURE__ */ import_react3.default.createElement(import_react_dates2.DateRangePicker, __spreadProps(__spreadValues({
    renderMonthElement,
    minimumNights: 0,
    ariaDescribedBy,
    enableOutsideDays: true,
    autoComplete: "date",
    numberOfMonths: 2
  }, datepickerProps), {
    startDate: getDateValue(startValue),
    startDateId: startId,
    endDate: getDateValue(endValue),
    endDateId: endId,
    calendarInfoPosition: "before",
    onDatesChange,
    focusedInput,
    disabled: attributes.disabled,
    onFocusChange,
    renderCalendarInfo: renderDateRanges,
    customArrowIcon,
    isOutsideRange: isOutsideRange(min, max, format),
    navPosition: "navPositionBottom",
    openDirection
  }))));
};
DateRange.propTypes = {
  id: import_prop_types4.default.string.isRequired,
  name: import_prop_types4.default.string.isRequired,
  validate: import_prop_types4.default.func,
  min: limitPropType,
  max: limitPropType,
  ariaDescribedBy: import_prop_types4.default.string,
  className: import_prop_types4.default.string,
  disabled: import_prop_types4.default.bool,
  onChange: import_prop_types4.default.func,
  onPickerFocusChange: import_prop_types4.default.func,
  innerRef: import_prop_types4.default.oneOfType([import_prop_types4.default.func, import_prop_types4.default.node]),
  format: import_prop_types4.default.string,
  datepickerProps: import_prop_types4.default.object,
  "data-testid": import_prop_types4.default.string,
  autoSync: import_prop_types4.default.bool,
  ranges: import_prop_types4.default.oneOfType([import_prop_types4.default.bool, import_prop_types4.default.array, import_prop_types4.default.object]),
  customArrowIcon: import_prop_types4.default.oneOfType([import_prop_types4.default.string, import_prop_types4.default.node]),
  openDirection: import_prop_types4.default.string,
  allowInvalidDates: import_prop_types4.default.bool
};
var DateRange_default = DateRange;

// src/DateRangeField.js
var import_react4 = __toESM(require("react"));
var import_prop_types5 = __toESM(require("prop-types"));
var import_form2 = require("@availity/form");
var DateRangeField = (_a) => {
  var _b = _a, {
    name,
    label,
    labelClass,
    labelHidden,
    labelAttrs,
    id = name,
    required,
    helpId
  } = _b, props = __objRest(_b, [
    "name",
    "label",
    "labelClass",
    "labelHidden",
    "labelAttrs",
    "id",
    "required",
    "helpId"
  ]);
  return /* @__PURE__ */ import_react4.default.createElement(import_form2.FormGroup, {
    for: name
  }, label && /* @__PURE__ */ import_react4.default.createElement(import_form2.Label, __spreadValues({
    for: `${id.replace(/[^\da-z]/gi, "")}-start`,
    className: labelClass,
    hidden: labelHidden,
    required,
    helpId
  }, labelAttrs), label), /* @__PURE__ */ import_react4.default.createElement(DateRange_default, __spreadValues({
    name,
    id,
    ariaDescribedBy: `${name.toLowerCase()}-feedback`
  }, props)), /* @__PURE__ */ import_react4.default.createElement(import_form2.Feedback, {
    name
  }));
};
DateRangeField.propTypes = {
  id: import_prop_types5.default.string,
  name: import_prop_types5.default.string.isRequired,
  label: import_prop_types5.default.node,
  labelClass: import_prop_types5.default.string,
  labelHidden: import_prop_types5.default.bool,
  labelAttrs: import_prop_types5.default.object,
  required: import_prop_types5.default.bool,
  helpId: import_prop_types5.default.string
};
var DateRangeField_default = DateRangeField;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DateField,
  DateRange,
  DateRangeField
});
